import React from 'react';
import ReactDOM from 'react-dom';
import axios from "axios";
import Axios from './Plugins/Axios'
import './App.scss';
import './MediaQuery.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/font/kalameh.ttf';
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux"
import Cookies from 'js-cookie'
import store from './Store/Store'
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const Ax=new Axios()
Ax.defaultHeaders()
const theme = createMuiTheme({
    overrides: {
        MuiPaper: {
            root: {
                width: '50% !important',
                maxWidth: '500px !important',
                minWidth: '400px !important',
                overflow:'visible !important'
                // height:'100%'
            },
        },
        MuiDialogContent: {
            root: {
                overflow:'visible !important'
                // height:'100%'
            },
        },
        MuiSnackbar: {
            root: {
                direction:'rtl !important'
                // height:'100%'
            },
        },
        MuiSnackbarContent:{
            root:{
                direction:'rtl !important',
            }
        }
    }
});

const appLoaded=Cookies.get('appLoaded')
if ( appLoaded ==='' || appLoaded === undefined) {
    if (window.location.pathname!=='/')
        window.location.href='/'
}
else {
    Ax.setAuth(Cookies.get('appLoaded'))
    // axios.defaults.headers.common['Authorization']=`Bearer ${Cookies.get('appLoaded')}`
}
if (window.location.pathname==='/')
    if (appLoaded && appLoaded !=='')
        window.location.href='/home'

ReactDOM.render(
    <Provider store={store}>
        <React.StrictMode>
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ThemeProvider>
        </React.StrictMode>
    </Provider>
    ,
    document.getElementById('root')
);
reportWebVitals();